export const getIntentDisplayLabel = (intent: string): string => {
  const titleCaseIntent = intent
    .split("_")
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

  return `Likely ${titleCaseIntent}`;
};
